export const downloaderEnums = {
    ACOMBA_EXPORT : "Acomba",
    CLIENT_EXPORT: "Client",
    RECEVABLE_EN: "Receivables",
    RECEVABLE_FR: "Recevables",
    CLIENT_SALARY_EXPORT_EN: "Members salary export",
    CLIENT_SALARY_EXPORT_FR: "Exportation des salaires des membres",
    MEMBER_MAJOR_CARD_EN: "Member major card",
    MEMBER_MAJOR_CARD_FR: "Carte membre major",
    CLIENT_REPORT_EN: "Client report",
    CLIENT_REPORT_FR: "Rapport client",
    INSURER_EXPORT_EN: "Insurer export",
    INSURER_EXPORT_FR: "Export assureur",
    AUTO_CLOSE: 5000
};


// WEBPACK FOOTER //
// ./src/utils/downloader/downloaderEnums.js